import SubmitCashClaimActualsPage from "./SubmitCashClaimActualsPage";

export default SubmitCashClaimActualsPage;
